<template>
  <div class="inline-block">
    <el-badge
      :is-dot="!!data.length"
      id="reminder"
      class="pointer mr-35 reminder active"
      :class="data.length ? 'active' : ''"
    >
      <svg-icon iconClass="reminder" className="reminder"></svg-icon>
    </el-badge>
    <b-popover
      target="reminder"
      triggers="click"
      custom-class="reminder-content"
      placement="bottomleft"
    >
      <template v-slot:title>{{ $t('text.reminders').toUpperCase() }}</template>
      <div class="content-desc mt-10">
        {{ $t('text.update_data_privacy_consent').toUpperCase() }}
      </div>
      <el-table
        size="mini"
        :data="data"
        border
        style="width: 100%"
        class="mt-15 mb-20"
        max-height="400"
      >
        <el-table-column prop="alias" :label="$t('text.user')">
        </el-table-column>
        <el-table-column :label="$t('text.last_updated')">
          <template slot-scope="scope">
            <span
              >{{
                userLang.indexOf('en') > -1
                  ? moment(scope.row.LastUpdatedDate).format('DD MMM YY')
                  : moment(scope.row.LastUpdatedDate).format('DD/MM/YY')
              }}
              ({{ scope.row.diffDays }}d ago)</span
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('text.action')">
          <template slot-scope="scope">
            <div class="blue-font underline pointer" @click="update(scope.row)">
              {{ $t('text.update') | firstLetterCapitalize }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </b-popover>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import moment from 'moment'
import swal from 'sweetalert'
export default {
  data() {
    return {
      moment,
      userLang: navigator.language || navigator.userLanguage,
      data: [],
      timer: ''
    }
  },
  mounted() {
    this.getConsents()
    this.timer = setInterval(this.getConsents, 10000)
  },
  methods: {
    getConsents() {
      ApiService.GetConsents()
        .then(response => {
          if (response.data.success) {
            this.data = response.data.data.map(item => {
              return {
                ...item,
                diffDays: moment().diff(moment(item.LastUpdatedDate), 'days')
              }
            })
            //order by diffDays
            this.data.sort(function(a, b) {
              if (a.diffDays > b.diffDays) {
                return -1
              } else if (a.diffDays == b.diffDays) {
                return 0
              } else {
                return 1
              }
            })
          }
        })
        .catch(() => {})
    },
    update(row) {
      if (row.UserId.indexOf('00000000') === 0) {
        this.savePatientConsent(row)
      }
      if (row.patientId.indexOf('00000000') === 0) {
        this.saveUserConsent(row)
      }
    },
    savePatientConsent(row) {
      ApiService.SavePatientConsent({
        PatientId: row.patientId,
        IsPrivacyPolicyChecked: true,
        IsDevicePolicyChecked: true,
        IsMarketingChecked: true
      })
        .then(response => {
          if (response.data.success) {
            this.getConsents()
            swal({
              icon: 'success',
              timer: 2000,
              title: 'Update Successfully'
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Update Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Update Failed'
          })
        })
    },
    saveUserConsent(row) {
      ApiService.SaveUserConsent({
        UserId: row.UserId,
        IsPrivacyChecked: true,
        IsTermsandConditionChecked: true
      })
        .then(response => {
          if (response.data.success) {
            this.getConsents()
            swal({
              icon: 'success',
              timer: 2000,
              title: 'Update Successfully'
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Update Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Update Failed'
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
